export default {
  FareOptionDetails__CONTINUE_BUTTON_LABEL: "Continue",
  FareOptionDetails__EARN_LABEL: "Earn",
};
